﻿$(() => {
	function validate($group: JQuery<Element>) {
		if ($group.prop("disabled")) {
			return true;
		}

		return $(":input", $group).get().reduce((previous, element) => {
			return $(element).valid() && previous;
		}, true);
	}

	$("fieldset [data-causes-validation]").on("click", (event: JQueryEventObject) => {
		let $group = $(event.currentTarget).closest("fieldset");

		if (!validate($group)) {
			event.stopImmediatePropagation();
			$group.trigger("error.validation-group");
		}
	});

	$("fieldset").on("validate", (event: JQueryEventObject) => {
		let $group = $(event.currentTarget);

		if (!validate($group)) {
			event.stopImmediatePropagation();
			$group.trigger("error.validation-group");
		}
	});

	$("fieldset :text").on("keydown", (event: JQueryEventObject) => {
		if (event.which === 13) {
			let $group = $(event.currentTarget).closest("fieldset");

			if (!validate($group)) {
				$group.trigger("error.validation-group");
			}
		}
	});
});
